import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import { Fade } from "react-reveal";
import { projectsHeader, projects } from "../../portfolio.js";
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";
import { style } from "glamor";

function Projects(props) {
  const theme = props.theme;
  const [filter, setFilter] = useState("All");
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Extract unique categories from projects
  const categories = [
    "All",
    ...new Set(projects.data.map((project) => project.category || "Other")),
  ];

  // Filter projects based on selected category
  const filteredProjects =
    filter === "All"
      ? projects.data
      : projects.data.filter((project) => project.category === filter);

  const styles = style({
    backgroundColor: `${theme.accentBright}`,
    ":hover": {
      boxShadow: `0 5px 15px ${theme.accentBright}`,
    },
  });

  return (
    <div className="projects-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="projects-heading-div">
            <div className="projects-heading-img-div">
              <ProjectsImg theme={theme} />
            </div>
            <div className="projects-heading-text-div">
              <h1
                className="projects-heading-text"
                style={{ color: theme.text }}
              >
                {projectsHeader.title}
              </h1>
              <p
                className="projects-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {projectsHeader["description"]}
              </p>
            </div>
          </div>
        </Fade>

        {/* Category Filter Buttons */}
        <Fade bottom duration={1000} distance="20px">
          <div className="project-filters">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`filter-btn ${filter === category ? "active" : ""}`}
                style={{
                  color: filter === category ? "white" : theme.text,
                  backgroundColor:
                    filter === category
                      ? "transparent" // This will be overridden by the active class gradient
                      : "transparent",
                  border:
                    filter === category ? "none" : `1px solid ${theme.text}`,
                }}
                onClick={() => setFilter(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </Fade>
      </div>

      <Fade
        bottom
        duration={1000}
        distance="20px"
        fraction={isMobile ? 0.1 : 0.3}
        spy={filter}
      >
        <div className="repo-cards-div-main">
          {filteredProjects.map((project) => {
            return (
              <ProjectCard repo={project} theme={theme} key={project.id} />
            );
          })}
        </div>
      </Fade>

      {/* Wrap button in container for proper alignment */}
      <Fade bottom duration={1000} distance="20px">
        <div className="button-container">
          <a
            {...styles}
            className="general-btn"
            href="https://github.com/svijayb"
          >
            More Projects (Github)
          </a>
        </div>
      </Fade>

      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default Projects;
